import { LANDING_PAGE_TYPES } from 'constants/index';
import i18n from 'i18n';
import { getLangingPageType } from 'utils/itineraries/functions';

const getNavLinks = (data) => {
  const res = (data?.pages?.[0]?.blocks || []).reduce((acc, block) => {
    if (!block._destroy) {
      if (block.type === 'header') {
        acc.push(block.data.subheadline);
      } else if (acc.length === 0) {
        acc.push('Start of the page');
      }
    }

    return acc;
  }, []);

  return res.map((r, i) => getTitleId(r, i));
};

export default getNavLinks;

export const getItineraryNavLinks = (pages) => {
  let res = [];
  res = pages.reduce((acc, page) => {
    if (page) {
      if (getLangingPageType(page) === LANDING_PAGE_TYPES.COVER_PAGE) {
        acc.push(i18n.t('proposal_content.cover_page'));
      } else {
        acc.push(page?.headline);
      }
    }

    return acc;
  }, []);

  return res.map((r, i) => getTitleId(r, i));
};

export function getTitleId(title = '', index) {
  if (!title) return;
  return title.split(' ').concat(index).join('__');
}

export function getOriginTitle(id = '') {
  return id.split('__').slice(0, -1).join(' ');
}
